"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterFcmTokenDtoPlatformEnum = void 0;
exports.instanceOfRegisterFcmTokenDto = instanceOfRegisterFcmTokenDto;
exports.RegisterFcmTokenDtoFromJSON = RegisterFcmTokenDtoFromJSON;
exports.RegisterFcmTokenDtoFromJSONTyped = RegisterFcmTokenDtoFromJSONTyped;
exports.RegisterFcmTokenDtoToJSON = RegisterFcmTokenDtoToJSON;
exports.RegisterFcmTokenDtoToJSONTyped = RegisterFcmTokenDtoToJSONTyped;
/**
 * @export
 */
exports.RegisterFcmTokenDtoPlatformEnum = {
    Web: 'web',
    Android: 'android',
    Ios: 'ios'
};
/**
 * Check if a given object implements the RegisterFcmTokenDto interface.
 */
function instanceOfRegisterFcmTokenDto(value) {
    if (!('deviceId' in value) || value['deviceId'] === undefined)
        return false;
    if (!('deviceName' in value) || value['deviceName'] === undefined)
        return false;
    if (!('pushNotificationToken' in value) || value['pushNotificationToken'] === undefined)
        return false;
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    return true;
}
function RegisterFcmTokenDtoFromJSON(json) {
    return RegisterFcmTokenDtoFromJSONTyped(json, false);
}
function RegisterFcmTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'deviceId': json['deviceId'],
        'deviceName': json['deviceName'],
        'pushNotificationToken': json['pushNotificationToken'],
        'platform': json['platform'],
    };
}
function RegisterFcmTokenDtoToJSON(json) {
    return RegisterFcmTokenDtoToJSONTyped(json, false);
}
function RegisterFcmTokenDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'deviceId': value['deviceId'],
        'deviceName': value['deviceName'],
        'pushNotificationToken': value['pushNotificationToken'],
        'platform': value['platform'],
    };
}
